import { useEffect, useState } from 'react';
import { getContentBySection } from '../../api/content';
import './Hero.css';

const LOGO_BEE = `${process.env.PUBLIC_URL}/logos/logo-branca-abelha.svg`;

const DEFAULTS = {
  eyebrow: 'Software House · Belo Horizonte',
  h1_linha1: 'Gestão',
  h1_linha2: 'inteligente.',
  h1_linha3: 'Resultados reais.',
  descricao: 'Desenvolvemos sistemas de gestão robustos, escaláveis e pensados para a realidade do mercado brasileiro. Da automação de processos ao BI avançado.',
  stat_clientes_valor: '+500',
  stat_clientes_label: 'Clientes',
  stat_anos_valor: '+15',
  stat_anos_label: 'Anos',
  stat_estados_valor: '+20',
  stat_estados_label: 'Estados',
};

const Hero = () => {
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    getContentBySection('hero').then(data => {
      if (Object.keys(data).length > 0) {
        setContent(prev => ({ ...prev, ...data }));
      }
    }).catch(() => {});
  }, []);

  const stats = [
    { value: content.stat_clientes_valor, label: content.stat_clientes_label },
    { value: content.stat_anos_valor, label: content.stat_anos_label },
    { value: content.stat_estados_valor, label: content.stat_estados_label },
  ];

  return (
    <section className="hero" id="hero">
      <img src={LOGO_BEE} alt="" aria-hidden="true" className="hero__bg-bee" />
      <div className="hero__hex-fade" aria-hidden="true" />

      <div className="hero__top">
        <div className="hero__headline-block">
          <div className="hero__eyebrow">
            <span className="hero__eyebrow-line" />
            <span className="hero__eyebrow-text">{content.eyebrow}</span>
          </div>
          <h1 className="hero__h1">
            <span className="hero__h1-white">{content.h1_linha1}</span>
            <span className="hero__h1-white">{content.h1_linha2}</span>
            <span className="hero__h1-outline">
              {content.h1_linha3.replace(' reais.', '')} <em>reais.</em>
            </span>
          </h1>
        </div>
      </div>

      <div className="hero__divider" aria-hidden="true" />

      <div className="hero__bottom">
        <p className="hero__desc">{content.descricao}</p>
        <div className="hero__stats">
          {stats.map(({ value, label }) => (
            <div className="hero__stat" key={label}>
              <span className="hero__stat-value">{value}</span>
              <span className="hero__stat-label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;